import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id FC900F32-A228-4E42-9E09-EA7CCDEC08F2
 * name ethernet-cable
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ethernet-cable.svg
 * tags
 */
export const EthernetCableIcon = createSvgIcon(<><path d="M11,3V7H13V3H11M8,4V11H16V4H14V8H10V4H8M10,12V22H14V12H10Z" /></>, 'EthernetCableIcon');
export default EthernetCableIcon